import type { Group } from '@percent/admin-dashboard/api/actions/groups/groups.types'

export const mockGroups: Group[] = [
  {
    id: 'group-1',
    name: 'Finance Team',
    description: 'Finance and reconciliation',
    memberCount: 4,
    roleCount: 1,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 'group-2',
    name: 'Engineering Team',
    description: 'Platform engineers',
    memberCount: 8,
    roleCount: 2,
    createdAt: '2024-01-02T00:00:00Z',
    updatedAt: '2024-01-02T00:00:00Z'
  }
]

export const mockGroupsResponse = {
  object: 'group',
  data: mockGroups,
  totalResults: mockGroups.length,
  pageSize: 10
}
